import { Component } from '@angular/core';

@Component({
  selector: 'app-recruitment-portal',
  templateUrl: './recruitment-portal.component.html',
  styleUrls: ['./recruitment-portal.component.scss']
})
export class RecruitmentPortalComponent {

  onUnivateRec(){
    // window.open('https://univate.ie/v2/old_p/main-dashboard',"_blank")
    // window.open('https://univate.ie/portal/old_p/main-dashboard',"_blank")
    window.open('https://univate.ie/portal/old_p/recruitment-report',"_blank")
  }
}
 